import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { useCrudSelection, resetCrudSelection, useEditingStateWithCtx } from '@/atoms'
import { selectPlacesListStructure } from '@/features/domain/lists'
import { fitMapToSelection } from '@/map'

export function useTitle() {
  const listStructure = useSelector(selectPlacesListStructure)
  const { editing } = useEditingStateWithCtx('place')

  const [selection, select] = useCrudSelection('places')

  const onSelectAll = useCallback(() => {
    const allSelected = listStructure.shownItems <= selection.length

    if (allSelected) {
      resetCrudSelection('places')
    } else {
      select(
        listStructure.list.reduce<string[]>((acc, item) => {
          if (typeof item === 'string') {
            acc.push(item)
          }
          return acc
        }, []),
      )

      fitMapToSelection({ preventIfVisible: true }, 'add')
    }
  }, [select, selection, listStructure])

  return {
    editing,
    selection,
    onSelectAll,
    listStructure,
    noEntries: listStructure.totalItems === 0,
  }
}
